<template>
    <div>
        <div class="splide" id="campaign-pictures" v-if="imageList.length > 1">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"
                        v-for="(image, k) in imageList"
                        :key="k">
                        <div class="campaign-image">
                            <img class="w-full" :src="image.fullImageUrl" alt="">
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div v-else class="campaign-image mb-4">
            <img class="w-full" :src="imageList[0].fullImageUrl" alt="">
        </div>
        <div class="w-full pb-4" v-if="imageList.length > 1">
            <img src="@/assets/bg/shadow.svg" alt=""/>
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide'; //https://splidejs.com/

export default {
    name: "Picture",
    props: {
        campaign: { type: Object, required: true },
    },
    data: function() {
        return {
            imageList: this.campaign.pictures,
        };
    },
    mounted: function() {
        if (this.imageList.length > 1) {
            new Splide('#campaign-pictures', {
                type: 'loop',
                arrows: false,
            }).mount();
        }
    },
}
</script>
<style lang="scss" >
    #campaign-pictures {
        padding-bottom: 25px;
        .splide__pagination{
            bottom: 0;
            .splide__pagination__page  {
                background-color: #979797;
                height: 4px;
                width: 4px;

                &.is-active {
                    background-color: #53b546;
                }
            }
        }

    }
</style>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        @include baseRatioImg($ratio: 66.66%);
        border-radius: 12px;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.12);
        overflow: hidden;
    }


</style>
